import { GetResourceUtilizationResponse } from '../../api-service/clients';
import { moduleClientFactory } from '../../api-service/module-client-factory';
import { formatDate } from '../../utilities';

const resourceUtilizationClient = moduleClientFactory.createServiceProviderUnitResourceUtilizationClient();

export function getResourceUtilization(date: Date): Promise<GetResourceUtilizationResponse> {
  return resourceUtilizationClient.getResourceUtilization({ date: formatDate(date, 'yyyy-MM-dd') });
}
